import { Injectable, signal } from '@angular/core';

export type ToastType =
  | 'success'
  | 'error';

export interface ToastMessage {
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  readonly toast =
    signal<ToastMessage | null>(null);

  private timeout?: number;

  private readonly maxMessageLength =
    200;


  success(
    message: string
  ): void {

    this.show(
      message,
      'success'
    );
  }


  error(
    message: string
  ): void {

    this.show(
      this.normalizeErrorMessage(
        message
      ),
      'error'
    );
  }


  show(
    message: string,
    type: ToastType = 'success'
  ): void {

    if (this.timeout) {
      window.clearTimeout(
        this.timeout
      );
    }

    this.toast.set({
      message,
      type
    });

    this.timeout =
      window.setTimeout(
        () => {
          this.toast.set(null);
        },
        3200
      );
  }


  dismiss(): void {

    if (this.timeout) {
      window.clearTimeout(
        this.timeout
      );
    }

    this.toast.set(null);
  }


  private normalizeErrorMessage(
    message: string
  ): string {

    const value =
      message?.trim();

    if (!value) {
      return 'Something went wrong. Please try again.';
    }

    if (
      value.length >
      this.maxMessageLength
    ) {

      console.error(
        'Toast error message exceeded display limit:',
        value
      );

      return 'Something went wrong. Please try again.';
    }

    return value;
  }
}